import React, { useEffect, useState } from "react";
import api from "../lib/api";

const EV = {
  sent: ["inviata", "bg-zinc-800 text-zinc-300"], delivered: ["consegnata", "bg-emerald-900/60 text-emerald-300"],
  delivery_delayed: ["in ritardo", "bg-amber-900/60 text-amber-300"], bounced: ["respinta", "bg-red-900/60 text-red-300"],
  failed: ["non consegnata", "bg-red-900/60 text-red-300"], complained: ["segnalata spam", "bg-red-900/60 text-red-300"], suppressed: ["bloccata (soppressioni)", "bg-red-900/60 text-red-300"],
};

// Scheda cliente: stato dell'ultima email inviata (dal webhook Resend)
export function CustomerEmailStatus({ customer }) {
  const [last, setLast] = useState(customer.last_email);
  useEffect(() => {
    if (customer.last_email !== undefined) { setLast(customer.last_email); return; }
    let on = true;
    api.get(`/customers/${customer.id}`).then(({ data }) => on && setLast(data.last_email || null)).catch(() => on && setLast(null));
    return () => { on = false; };
  }, [customer.id, customer.last_email]);
  if (!last) return null;
  const [label, cls] = EV[last.last_event] || EV.sent;
  const bad = ["bounced", "failed", "complained", "suppressed"].includes(last.last_event);
  return (
    <div className="mt-1 text-xs flex flex-wrap items-center gap-1.5" data-testid="customer-email-status">
      <span className={`rounded-full px-2 py-0.5 font-semibold ${cls}`} data-testid="customer-email-status-badge">ultima email {label}</span>
      {last.engagement && <span className="rounded-full px-2 py-0.5 bg-sky-900/60 text-sky-300">{last.engagement === "opened" ? "aperta" : "click"}</span>}
      <span className="text-zinc-500">{(last.sent_at || "").slice(0, 10)} · {last.subject}</span>
      {bad && <span className="text-red-300 w-full" data-testid="customer-email-status-reason">{last.bounce?.message || last.failed_reason || "Verifica e correggi l'indirizzo email."}</span>}
    </div>
  );
}
